import React, { useEffect, useState } from "react";
import { getGraficas } from "../../common/CygniRequests";
import { Typography, Box, Divider } from "@material-ui/core";
import { queryPrep } from "../../common/Cygni";
import { CygniPieChart } from "../../common/CygniPieChart";
import { CygniLoadingFix } from "../../common/CygniLoading";
import { VisContainer } from "../../common/CygniContainers";
import * as FileSaver from "file-saver";
import { useRechartToPng } from "recharts-to-png";

export const ClasificacionNotas = React.memo(({ queries, current }) => {
  const [data, setData] = useState(null);
  const [png, ref] = useRechartToPng();

  const downloadChart = React.useCallback(async () => {
    FileSaver.saveAs(png, "clasif.png");
  }, [png]);

  useEffect(() => {
    setData(null);

    var clasif = [];
    var resMap = queries.map(async (el, i) => {
      if (
        current.id.includes(-1) ||
        (!current.id.includes(-1) && current.id.includes(el.qry_id))
      ) {
        var res = await getGraficas(
          queryPrep(el.query),
          current.fi.replace(/-/g, "_"),
          current.ff.replace(/-/g, "_"),
          "cygnimovilmedio"
        );

        var d = [];
        Object.values(res).forEach((c) => {
          d.push(c);
        });

        clasif.push({ query: el.qry_nombre, data: d });
      }
    });

    // Wait for all requests, and then setState
    Promise.all(resMap).then(() => {
      setData(clasif);
    });
  }, [current, queries]);

  let categLabel = function (entry) {
    return entry.name;
  };

  return (
    <VisContainer
      title="Clasificación Medios"
      desc="Clasificación de actor(es) en medios tradicionales."
      time={data ? true : false}
      showMenu={!(current.id.includes(-1) || current.id.length > 1)}
      downloadChart={downloadChart}
    >
      {!data && <CygniLoadingFix />}
      {data &&
        current.id !== -1 &&
        !current.id.includes(-1) &&
        current.id.length === 1 && (
          <CygniPieChart
            dataKey="value"
            data={data[0].data}
            labelLine={true}
            label={categLabel}
            //   chartClick={chartClick}
            exportRef={ref}
            legend={true}
          />
        )}
      {data && (current.id.includes(-1) || current.id.length > 1) && (
        <Box>
          {data &&
            data.length > 0 &&
            data.map((el, i) => {
              return (
                <React.Fragment key={i}>
                  <Typography
                    variant="h6"
                    color="primary"
                    style={{ marginLeft: "1rem" }}
                  >
                    {el.query}
                  </Typography>
                  {el.data &&
                    el.data.length > 0 &&
                    el.data.map((d, j) => {
                      return (
                        <Typography
                          key={j}
                          variant="subtitle1"
                          color="textSecondary"
                          align="right"
                          style={{ marginRight: "1rem" }}
                        >
                          {d.name + ": " + d.value}
                        </Typography>
                      );
                    })}
                  <Divider style={{ margin: "1rem" }} />
                </React.Fragment>
              );
            })}
        </Box>
      )}
    </VisContainer>
  );
});
